function currencyFormatter(amount) {
    let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(amount);
}

function numberFormatter(number) {
    let formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(number);
}

function dateFormatter(dateStr, locale) {
    let [y, m, d] = dateStr.split('-');
    let localeMonth = {
        en: {
            "01": "Jan",
            "02": "Feb",
            "03": "Mar",
            "04": "Apr",
            "05": "May",
            "06": "Jun",
            "07": "Jul",
            "08": "Aug",
            "09": "Sep",
            "10": "Oct",
            "11": "Nov",
            "12": "Dec",
        },
        es: {
            "01": "Ene",
            "02": "Feb",
            "03": "Mar",
            "04": "Abr",
            "05": "May",
            "06": "Jun",
            "07": "Jul",
            "08": "Ago",
            "09": "Sep",
            "10": "Oct",
            "11": "Nov",
            "12": "Dic",
        }
    }
    return `${d} ${localeMonth[locale][m]} ${y}`;
}

function accountNumberFormatter(accountNumber) {    
    return accountNumber ? accountNumber.replace(/[a-zA-Z0-9]{4}(?=.)/g, '$& ') : '';
}

export default {
    currencyFormatter,
    numberFormatter,
    dateFormatter,
    accountNumberFormatter,
}